module.exports = __webpack_public_path__ + "media/bgm.8c34f278.mp3";